export const LEGACY_NO_PRODUCTS_MESSAGE = 'This brand has no products yet — add one first (angle sets are product-scoped), then ask me to plan angles again.';

export function noProductsMessage(brandId: number): string {
  const explanation = 'This brand doesn’t have any products yet. Add a product so I can use its details to create your ads.';
  if (!Number.isSafeInteger(brandId) || brandId <= 0) return explanation;
  return `${explanation}\n\n[Add a product](/brands/${brandId}/products/new)\n\nThen return to this chat and send your request again.`;
}

/** Upgrade only the exact old system response; never rewrite other conversation content. */
export function upgradeNoProductsMessage(content: string, brandId?: number | null): string {
  return content.trim() === LEGACY_NO_PRODUCTS_MESSAGE && brandId != null
    ? noProductsMessage(brandId) : content;
}
